var map = {
	"./404.svg": "MmNR",
	"./address-line.svg": "tTWc",
	"./address-name.svg": "b+9K",
	"./address-phone.svg": "ReTd",
	"./balance.svg": "C89c",
	"./benefits.svg": "5Zu3",
	"./bug.svg": "sC8t",
	"./chart.svg": "Selq",
	"./clipboard.svg": "mxA3",
	"./component.svg": "Jzjd",
	"./customer.svg": "pa5k",
	"./dashboard.svg": "0bI4",
	"./documentation.svg": "Lvc4",
	"./download.svg": "+5f7",
	"./drag.svg": "UtWV",
	"./edit.svg": "79Rt",
	"./education.svg": "5jHK",
	"./email.svg": "SCWQ",
	"./enterprise.svg": "k0mT",
	"./example.svg": "3IhI",
	"./excel.svg": "kja8",
	"./exit-fullscreen.svg": "Qa4w",
	"./export.svg": "IbHD",
	"./eye-open.svg": "XW5B",
	"./eye.svg": "lkYc",
	"./facebook.svg": "qduP",
	"./file.svg": "AMQM",
	"./form.svg": "ENXG",
	"./fullscreen.svg": "PaQK",
	"./guide.svg": "ZSu0",
	"./ic_down.svg": "QnFo",
	"./ic_search.svg": "39XR",
	"./ic_up.svg": "gSxi",
	"./icon-delete.svg": "93lJ",
	"./icon-ic_screenshot.svg": "xg1K",
	"./icon.svg": "MHaj",
	"./icon_add.svg": "gmiZ",
	"./icon_error.svg": "ZqXY",
	"./icon_face.svg": "iQdG",
	"./international.svg": "CZ8l",
	"./inventory.svg": "qnSW",
	"./language.svg": "eq/1",
	"./link.svg": "MdCa",
	"./list.svg": "Y/s1",
	"./lock.svg": "50qg",
	"./logo-mini.svg": "wMOj",
	"./logo.svg": "UvJY",
	"./logo1.svg": "IXPQ",
	"./logout.svg": "Lukg",
	"./message.svg": "gLz0",
	"./method.svg": "sRUd",
	"./money.svg": "VNQQ",
	"./nested.svg": "VkTp",
	"./note.svg": "Gkr0",
	"./password.svg": "VjgG",
	"./pdf.svg": "EGne",
	"./people.svg": "On2Q",
	"./peoples.svg": "9xKE",
	"./qq.svg": "lzol",
	"./record.svg": "9q4B",
	"./search.svg": "+N6X",
	"./setting.svg": "UHh0",
	"./shopcart.svg": "RWD3",
	"./shopping.svg": "d18r",
	"./size.svg": "pjsL",
	"./skill.svg": "ANQB",
	"./star.svg": "8Rc7",
	"./subtract.svg": "5Ro/",
	"./tab.svg": "ZP5S",
	"./table.svg": "b8xz",
	"./theme.svg": "o0Wp",
	"./tree-table.svg": "MGqv",
	"./tree.svg": "7Z14",
	"./triangle.svg": "aFzg",
	"./user.svg": "QqR9",
	"./wechat.svg": "y8Os",
	"./zip.svg": "k1dB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Ak3";


//////////////////
// WEBPACK FOOTER
// ./src/user/icons/svg nonrecursive \.svg$
// module id = 1Ak3
// module chunks = 12